(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-qwerky"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Collection toolbar: SEO info panel, in-stock toggle and sub-category chips */
  class QcCollectionToolbar extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      this.addEventListener('change', this.#onChange);
      this.#restoreSubcategory();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('change', this.#onChange);
    }

    #onClick = (event) => {
      const chip = event.target.closest('[data-qc-sub]');
      if (chip) {
        this.#toggleSubcategory(chip.dataset.qcSub);
        return;
      }

      const button = event.target.closest('[data-qc-info-toggle]');
      if (!button) return;
      const panel = this.querySelector('[data-qc-info-panel]');
      if (!panel) return;
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    };

    #onChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-qc-stock]')) return;

      const url = new URL(window.location.href);
      const params = new URLSearchParams();
      for (const [key, value] of url.searchParams) {
        if (key === 'page' || key === 'filter.v.availability') continue;
        params.append(key, value);
      }
      if (input.checked) params.append('filter.v.availability', '1');
      url.search = params.toString();

      const facetsForm = this.closest('.shopify-section')?.querySelector('facets-form-component');
      if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(url.toString());
      } else {
        window.location.assign(url.toString());
      }
    };

    /* The active chip lives on <html data-qc-sub>, so it survives the section
       re-rendering after a filter/sort change. Chip blocks ship the CSS that
       moves their matching products to the top (order: -1). */
    #toggleSubcategory(key) {
      const root = document.documentElement;
      const next = root.dataset.qcSub === key ? '' : key;

      const apply = () => {
        if (next) {
          root.dataset.qcSub = next;
        } else {
          delete root.dataset.qcSub;
        }
        this.#syncChips();
      };

      if (document.startViewTransition) {
        document.startViewTransition(apply);
      } else {
        apply();
      }

      const url = new URL(window.location.href);
      if (next) {
        url.searchParams.set('sub', next);
      } else {
        url.searchParams.delete('sub');
      }
      history.replaceState(history.state, '', url.toString());

      const grid = this.closest('.shopify-section')?.querySelector('#ResultsList');
      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const barHeight = this.closest('.qc-bar')?.getBoundingClientRect().height || 0;
      if (grid && grid.getBoundingClientRect().top < headerHeight + barHeight) {
        window.scrollTo({
          top: grid.getBoundingClientRect().top + window.scrollY - headerHeight - barHeight,
          behavior: 'smooth',
        });
      }
    }

    #restoreSubcategory() {
      const key = new URL(window.location.href).searchParams.get('sub');
      if (key && this.querySelector(`[data-qc-sub="${CSS.escape(key)}"]`)) {
        document.documentElement.dataset.qcSub = key;
      }
      this.#syncChips();
    }

    #syncChips() {
      const active = document.documentElement.dataset.qcSub || '';
      for (const chip of this.querySelectorAll('[data-qc-sub]')) {
        chip.setAttribute('aria-pressed', String(chip.dataset.qcSub === active));
      }
    }
  }

  if (!customElements.get('qc-collection-toolbar')) {
    customElements.define('qc-collection-toolbar', QcCollectionToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-video-grid')) {
    customElements.define(
      'ugc-video-grid',
      class UgcVideoGrid extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.ugc-grid__dialog');
          this.video = this.querySelector('.ugc-grid__video');

          this.addEventListener('click', (event) => {
            const tile = event.target.closest('.ugc-grid__tile');
            if (tile) return this.open(tile);

            if (event.target.closest('[data-close]') || event.target === this.dialog) return this.close();

            const more = event.target.closest('[data-show-more]');
            if (more) {
              this.querySelectorAll('.ugc-grid__item--more[hidden]').forEach((item) => (item.hidden = false));
              more.closest('.ugc-grid__more').remove();
            }
          });

          this.dialog.addEventListener('close', () => this.stop());
        }

        stop() {
          this.video.pause();
          if (this.video.hasAttribute('src')) {
            this.video.removeAttribute('src');
            this.video.load();
          }
        }

        open(tile) {
          const src = tile.dataset.videoSrc;
          if (!src) return;
          this.video.poster = tile.dataset.poster || '';
          this.video.src = src;
          this.dialog.showModal();
          this.video.play().catch(() => {});
        }

        close() {
          this.stop();
          this.dialog.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
